import React from "react";
import HomescreenWidgetForm from "./HomescreenWidgetForm";

const EditHomescreenWidget = (props) => <HomescreenWidgetForm props={props} edit />;

export default EditHomescreenWidget;
